export * from './nbtips.module';
export * from './nbtips.component';
